module.exports = __webpack_public_path__ + "static/media/notif.ed9b1926.svg";